import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { NewsletterTeaser } from './NewsletterTeaser';

export interface NewsletterProps extends PropsWithClassProps {
  hasBackground?: boolean;
}

export const Newsletter = ({ classProps, hasBackground }: NewsletterProps) => {
  return <NewsletterTeaser classProps={classProps} hasBackground={hasBackground} />;
};
